import type { Viewer } from '../../viewer/Viewer';
import type { MeasureClosestPointResult } from '../types/measure-distance-types';
import type { MeasureEntityRef } from '../types/measure-types';
import { MeasureFarthestPointResolver } from './MeasureFarthestPointResolver';

/**
 * 两几何体全局最远点参考点策略。
 *
 * 职责：包装 {@link MeasureFarthestPointResolver}，供圆弧/圆最大距离子模式调用。
 */
export class MeasureFarthestPointReferenceStrategy {
    /** 最远点求解器。 */
    private readonly farthestPointResolver: MeasureFarthestPointResolver;

    /**
     * @param viewer Viewer 实例。
     */
    public constructor(viewer: Viewer) {
        this.farthestPointResolver = new MeasureFarthestPointResolver(viewer);
    }

    /**
     * 求解两实体之间的全局最远点。
     *
     * @param firstEntity 先选实体。
     * @param secondEntity 后选实体。
     * @returns 最远点结果；无法求解时返回 null。
     */
    public resolve(
        firstEntity: MeasureEntityRef,
        secondEntity: MeasureEntityRef,
    ): MeasureClosestPointResult | null {
        return this.farthestPointResolver.resolve(firstEntity, secondEntity);
    }
}
